import { SolutionOutlined } from "@ant-design/icons";
import { IRouteConfig } from "services/typings";
import { Permission, Resource } from "components/CurrentUser/constants";
import { lazy } from "utils/route";
import BlankLayout from "layouts/BlankLayout";

const routes: IRouteConfig[] = [
  {
    path: "/contract",
    name: "contract.title",
    icon: SolutionOutlined,
    component: BlankLayout,
    searchable: true,
    permissions: [
      [Resource.CONTRACT, Permission.VIEW],
      [Resource.CONTRACT, Permission.FULL_VIEW],
    ],
    routes: [
      {
        path: "/contract",
        name: "contract.title",
        hideInMenu: true,
        searchable: true,
        exact: true,
        component: lazy(() => import("./Contract")),
        permissions: [
          [Resource.CONTRACT, Permission.VIEW],
          [Resource.CONTRACT, Permission.FULL_VIEW],
        ],
        placeholderConfig: {
          filter: true,
        },
      },
      {
        path: "/contract/create",
        name: "contract.new_contract",
        hideInMenu: true,
        searchable: true,
        exact: true,
        component: lazy(() => import("./pages/ContractCompose")),
        permissions: [
          [Resource.CONTRACT, Permission.CREATE],
          [Resource.CONTRACT, Permission.FULL_CREATE],
        ],
      },
      {
        path: "/contract/:id",
        name: "contract.title",
        hideInMenu: true,
        searchable: true,
        exact: true,
        component: lazy(() => import("./pages/ContractDetail")),
        permissions: [
          [Resource.CONTRACT, Permission.VIEW],
          [Resource.CONTRACT, Permission.FULL_VIEW],
        ],
      },
      {
        path: "/contract/:id/edit",
        name: "contract.title",
        hideInMenu: true,
        searchable: true,
        exact: true,
        component: lazy(() => import("./pages/ContractCompose")),
        permissions: [
          [Resource.CONTRACT, Permission.UPDATE],
          [Resource.CONTRACT, Permission.FULL_UPDATE],
        ],
      },
      {
        path: "/contract/appendix/:appendix_id",
        name: "contract.title",
        hideInMenu: true,
        searchable: true,
        exact: true,
        component: lazy(
          () =>
            import(
              "./pages/ContractDetail/components/AppendixContract/AppendixDetail"
            )
        ),
        permissions: [
          [Resource.CONTRACT, Permission.VIEW],
          [Resource.CONTRACT, Permission.FULL_VIEW],
        ],
      },
      {
        path: "/contract/:id/:tab",
        name: "contract.title",
        hideInMenu: true,
        searchable: true,
        exact: true,
        component: lazy(() => import("./pages/ContractDetail")),
        permissions: [
          [Resource.CONTRACT, Permission.VIEW],
          [Resource.CONTRACT, Permission.FULL_VIEW],
        ],
      },
      {
        path: "/contract/:id/:tab/:appendix_id",
        name: "contract.title",
        hideInMenu: true,
        searchable: true,
        exact: true,
        component: lazy(
          () =>
            import(
              "./pages/ContractDetail/components/AppendixContract/AppendixDetail"
            )
        ),
        permissions: [
          [Resource.CONTRACT, Permission.VIEW],
          [Resource.CONTRACT, Permission.FULL_VIEW],
        ],
      },
    ],
  },
];

export default routes;
